import React, { useEffect, useState } from 'react';
import { ReportsService } from '../services/ZashaniService';
import { useAuth } from '../context/AuthContext';
import { MetricSkeleton } from '../components/LoadingStates';

const currency = new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' });

const Dashboard = () => {
    const { user } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        ReportsService.dashboard()
            .then(setData)
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, []);

    const cards = [
        ['Ventas hoy', currency.format(data?.todaySales || 0)],
        ['Pedidos hoy', data?.todaySalesCount || 0],
        ['Ventas del mes', currency.format(data?.monthSales || 0)],
        ['Pedidos pendientes', data?.pendingOrders || 0],
        ['Pedidos enviados', data?.shippedOrders || 0],
    ];

    if (user.role === 'admin') {
        cards.splice(1, 0, ['Ganancia hoy', currency.format(data?.todayProfit || 0)]);
        cards.push(['Bajo inventario', data?.lowStock || 0]);
    }

    return (
        <section className="content-section">
            <div className="section-heading">
                <div>
                    <p className="eyebrow">Resumen</p>
                    <h2>{user.role === 'admin' ? 'Panel administrativo' : 'Mi actividad'}</h2>
                </div>
            </div>
            {loading ? (
                <MetricSkeleton count={user.role === 'admin' ? 7 : 5} />
            ) : (
                <div className="metric-grid">
                    {cards.map(([label, value], index) => (
                        <article className="metric-card" key={label} style={{ '--delay': `${index * 70}ms` }}>
                            <span>{label}</span>
                            <strong>{value}</strong>
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
};

export default Dashboard;
